module.exports = __webpack_public_path__ + "img/banner-bg.be684304.png";